// 既存のグローバルjQueryを使用（上書きしない）
const $ = window.$ || window.jQuery || require('jquery')

// js-beautifyをインポート
import beautify from 'js-beautify'

require('bootstrap')

export default {

  data() {
    return {
      editor: null,
      editorElement: null,
      currentLinkInfo: null,
      savedRange: null,
      wysiwygSelectedFileName: null,
      cleanupTimeout: null,
      selectedImageElement: null,
      imageEditTarget: null
    }
  },

  methods: {
    // ========================================
    // Summernote初期化
    // ========================================
    initSummernote(selector, customOptions = {}) {
      // 初期化時に要素を保存
      this.editorElement = $(selector);
      
      // 要素が存在しない場合は初期化しない
      if (!this.editorElement.length) {
        console.warn('Summernote: 要素が見つかりません', selector);
        return;
      }
      
      // 既に初期化済みの場合は破棄してから再初期化
      if (this.editor) {
        try {
          this.editor.summernote('destroy');
        } catch (e) {
          console.warn('Summernote: 既存のエディタの破棄に失敗', e);
        }
        this.editor = null;
      }
      
      // デフォルトのスタイルタグ設定
      const defaultStyleTags = ['p', 'h2', 'h3', 'h4', 
        {
          title: '小さい文字',
          tag: 'p',
          className: 'c_small', 
          value: 'c_small',
          style: 'font-size: 0.75em;'
        }
      ];

      // デフォルトのスタイルラベル設定
      const defaultStyleLabels = {
        p: '標準',
        h2: '見出し1',
        h3: '見出し2',
        h4: '見出し3',
        h5: '見出し4',
        c_small: '小さい文字'
      };

      // カスタムオプションとマージ
      const styleTags = customOptions.styleTags || defaultStyleTags;
      const styleLabels = { ...defaultStyleLabels, ...(customOptions.styleLabels || {}) };
      
      // スタイルラベルをインスタンス変数として保存（initStyleDropdownで使用）
      this.styleLabels = styleLabels;
      
      // 標準の字上げ・字下げボタンを非表示にするCSSを追加
      if (!document.getElementById('hide-standard-indent-buttons')) {
        const style = document.createElement('style');
        style.id = 'hide-standard-indent-buttons';
        style.textContent = `
          .note-editable {
            font-size: 14px;
            line-height: 1.6;
            ul {
              list-style-type: disc;
            }
            ol {
              list-style-type: decimal;
            }
            h2 {
                font-size: 1.5em;
                font-weight: 700;
                margin-top: 0.83em;
                margin-bottom: 0.83em;
                line-height: 1.2;
            }
            h3 {
                font-size: 1.17em;
                font-weight: 700;
                margin-top: 1em;
                margin-bottom: 1em;
                line-height: 1.2;
            }
            h4 {
                font-size: 1em;
                font-weight: 700;
                margin-top: 1.33em;
                margin-bottom: 1.33em;
                line-height: 1.2;
            }
            h5 {
                font-size: 0.83em;
                font-weight: 700;
                margin-top: 1.67em;
                margin-bottom: 1.67em;
                line-height: 1.2;
            }
            p.c_small {
                font-size: 0.75em;
            }
          }

          .note-toolbar {
            .note-list {
                display: none !important;
            } 
            .note-para {
              .note-dropdown-menu {
                  min-width: auto !important;
              }
            }
            /* 均等割り付けのみ非表示にする */
            button:has(.note-icon-align-justify) {
              display: none !important;
            }
            a {
              color: inherit;
            }
            .note-btn {
              font-weight: normal;
              &.active {
                background-color: #337ab7 !important;
                color: #fff !important;
                border-color: #2e6da4 !important;
              }
            }
            .note-dropdown-menu {
              li.checked {
                background-color: #337ab7 !important;
                > a {
                  color: #fff !important;
                }
              }
              .c_summernote_select_p {
                font-size: 1em;
              }
              .c_summernote_select_h2 {
                font-size: 1.5em;
              }
              .c_summernote_select_h3 {
                font-size: 1.3em;;
              }
              .c_summernote_select_h4 {
                font-size: 1.2em;;
              }
              .c_summernote_select_h5 {
                font-size: 1.1em;;
              }
              /* 小さい文字用の段落スタイル */
              .c_summernote_select_small {
                font-size: 0.75em;
              }
            }
            button[data-event="foreColor"] {
              position: relative;
            }
            button[data-event="foreColor"].selected::after {
              content: "✓";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: white;
              text-shadow: 0 0 2px black, 0 0 2px black, 0 0 2px black;
              font-weight: bold;
              font-size: 14px;
              pointer-events: none;
            }
            .note-para .note-dropdown-menu {
              li.checked {
                background-color: #337ab7 !important;
                > a, > button {
                  color: #fff !important;
                }
              }
            }
            /* ファイルアップロードボタンのサイズ調整 */
            button[data-name="uploadFile"],
            button:has(.fa-upload) {
              font-size: 13px;
            }
          }
        `;
        document.head.appendChild(style);
      }

      // 【役割A】タグごと削除（Unwrap）したい場合に、このリストに追加
      const tagsToUnwrap = ['b', 'strong', 'i', 'em', 'u', 'font'];

      // 【役割B】スタイルクリアの判断材料とする装飾タグのリスト（内部的に使用）
      const presentationalTags = ['b', 'strong', 'i', 'em', 'u', 'span', 'font'];

      // 非表示にするボタンのリスト（customOptionsから取得）
      const hideButtons = customOptions.hideButtons || [];

      // ツールバー配列を構築（非表示ボタンを除外）
      const insertButtons = ['customPicture', 'uploadFile', 'customLink'].filter(btn => !hideButtons.includes(btn));
      
      const toolbar = [
        ['style', ['style']],
        ['font', ['bold']],
        ['color', ['forecolor']],
        ...(insertButtons.length > 0 ? [['insert', insertButtons]] : []),
        ['para', ['paragraph', 'ul', 'ol']],
        // ['para', ['paragraph']],
        ['fontclear', ['customClear']],
        ['view', ['codeview']]
      ];

      // buttonsオブジェクトを構築（非表示ボタンを除外）
      const buttons = {
        // ========================================
        // リンク関連ボタン
        // ========================================
        customLink: this.createCustomLinkButton,
        
        // ========================================
        // フォーマット関連ボタン
        // ========================================
        customIndent: this.createCustomIndentButton,
        customOutdent: this.createCustomOutdentButton,
        customClear: this.createCustomClearButton,
        
        // ========================================
        // 画像編集関連ボタン
        // ========================================
        setImageLink: this.createSetImageLinkButton,
        setImageAlt: this.createSetImageAltButton
      };

      // 非表示ボタンでない場合のみ、ファイル・メディア関連ボタンを追加
      if (!hideButtons.includes('uploadFile')) {
        buttons.uploadFile = this.createUploadFileButton;
      }
      if (!hideButtons.includes('customPicture')) {
        buttons.customPicture = this.createCustomPictureButton;
      }

      this.editor = this.editorElement.summernote({
        lang: 'ja-JP',
        height: 400,
        styleTags: styleTags,
        fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '36'],
        toolbar: toolbar,
        codeviewFilter: false,
        codeviewIframeFilter: false,
        defaultFontSize: '16',
        buttons: buttons,
        callbacks: {
          onChange: (contents) => {
            if(typeof this.updateComment === 'function') {
              // 編集中はクリーンアップせず、元のHTMLを渡す
              this.updateComment(contents);
            }
            // 変更時にもツールバー状態を更新
            this.updateToolbarState();
          },
          onBlur: () => {
            // blurイベントでのクリーンアップは一旦削除
          },
          // onFocusoutでのクリーンアップは削除（カーソル位置の問題を回避）
          onInit: () => {
            this.initSummernoteCallbacks();
            // デバッグ: ツールバーが正しく生成されたか確認
            const $toolbar = this.editorElement.next('.note-editor').find('.note-toolbar');
            if ($toolbar.length) {
              console.log('Summernote: ツールバーが正常に生成されました', $toolbar);
            } else {
              console.warn('Summernote: ツールバーが見つかりません');
            }
          }
        },
        popover: {
          color: {
            click: true // 色を選択したら即反映
          },
          image: [
            ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
            ['float', ['floatLeft', 'floatRight', 'floatNone']],
            ['custom', ['setImageLink', 'setImageAlt']],
            ['remove', ['removeMedia']]
          ]
        },
        // ツールチップや文字サイズの調整
        codemirror: {
          lineNumbers: true,
          theme: 'monokai'
        }
      });
      
      // コードビュートグル時のイベントを監視
      this.editorElement.on('summernote.codeview.toggled', () => {
        this.handleCodeViewToggle();
      });
    },

    // ========================================
    // Summernoteコールバック初期化
    // ========================================
    initSummernoteCallbacks() {
      // 色選択ボタンのクリックイベント
      $('.note-color-btn').on('click', function(e) {
        // 色を選択後、ポップオーバーを閉じる
        setTimeout(function() {
          $('.note-dropdown-menu').removeClass('show');
        }, 10);
      });
      
      // リンクボタンにdata-name属性を追加（ツールバーに追加された後）
      const $toolbar = this.editorElement.next('.note-editor').find('.note-toolbar');
      const $linkBtn = $toolbar.find('button:has(.note-icon-link)');
      if ($linkBtn.length) {
        $linkBtn.attr('data-name', 'customLink');
        console.log('[Link Button Init] data-name属性を追加しました', $linkBtn[0]);
      } else {
        console.warn('[Link Button Init] リンクボタンが見つかりません');
      }
      
      this.initStyleDropdown();
      this.initImageEvents();
      this.updateToolbarState();
      
      // エディタ領域のイベントリスナー追加
      const $editable = this.editorElement.next('.note-editor').find('.note-editable');
      $editable.on('mouseup.updateToolbar keyup.updateToolbar', () => {
        this.updateToolbarState();
      });
      
      // ツールバーボタンのクリック時
      $toolbar.on('click.updateToolbar', '.note-btn', () => {
        this.updateToolbarState();
      });
      
      // 色ボタンのクリック時
      $toolbar.on('click.colorUpdate', 'button[data-event="foreColor"]', () => {
        this.updateToolbarState();
      });
    },

    // ========================================
    // ツールバーの状態を更新
    // ========================================
    updateToolbarState() {
      if (!this.editor) {
        return;
      }

      const range = this.editor.summernote('createRange');
      if (!range) {
        return;
      }

      const $toolbar = this.editorElement.next('.note-editor').find('.note-toolbar');
      
      // 選択範囲の要素を取得
      let node = range.sc || range.startContainer;
      if (node.nodeType === Node.TEXT_NODE) {
        node = node.parentNode;
      }
      
      const $node = $(node);
      const computedStyle = window.getComputedStyle(node);
      
      // 太字のチェック
      const $boldBtn = $toolbar.find('.note-btn[data-name="bold"]');
      if ($node.closest('b, strong').length || 
          computedStyle.fontWeight === 'bold' || 
          computedStyle.fontWeight >= 700) {
        $boldBtn.addClass('active');
      } else {
        $boldBtn.removeClass('active');
      }
      
      // リンクのチェック
      const $linkBtn = $toolbar.find('button[data-name="customLink"], button:has(.note-icon-link)');
      if ($linkBtn.length) {
        // カーソル位置または選択範囲がリンク内にあるかチェック
        let isInLink = false;
        let $linkElement = null;
        
        // 1. 現在のノードがリンク内にあるかチェック
        $linkElement = $node.closest('a');
        if ($linkElement.length > 0) {
          isInLink = true;
        }
        
        // 2. 選択範囲の開始位置がリンク内にあるかチェック
        if (!isInLink && range.sc) {
          let startNode = range.sc;
          if (startNode.nodeType === Node.TEXT_NODE) {
            startNode = startNode.parentNode;
          }
          $linkElement = $(startNode).closest('a');
          if ($linkElement.length > 0) {
            isInLink = true;
          }
        }
        
        // 3. 選択範囲の終了位置がリンク内にあるかチェック
        if (!isInLink && range.ec) {
          let endNode = range.ec;
          if (endNode.nodeType === Node.TEXT_NODE) {
            endNode = endNode.parentNode;
          }
          $linkElement = $(endNode).closest('a');
          if ($linkElement.length > 0) {
            isInLink = true;
          }
        }
        
        // 4. commonAncestorがリンク内にあるかチェック
        if (!isInLink && typeof range.commonAncestor === 'function') {
          try {
            const ancestor = range.commonAncestor();
            if (ancestor) {
              $linkElement = $(ancestor).closest('a');
              if ($linkElement.length > 0) {
                isInLink = true;
              }
            }
          } catch (e) {
            // commonAncestorが利用できない場合は無視
          }
        }
        
        // アップロードされたファイルのリンクの場合はアクティブにしない
        if (isInLink && $linkElement && $linkElement.length > 0) {
          if ($linkElement.attr('data-uploaded-file') === 'true') {
            isInLink = false;
          }
        }
        
        if (isInLink) {
          $linkBtn.addClass('active');
        } else {
          $linkBtn.removeClass('active');
        }
      }
      
      // ファイルアップロードボタンのチェック
      const $uploadFileBtn = $toolbar.find('button[data-name="uploadFile"], button:has(.fa-upload)');
      if ($uploadFileBtn.length) {
        // カーソル位置または選択範囲がアップロードされたファイルのリンク内にあるかチェック
        let isInUploadedFileLink = false;
        let $uploadedFileLinkElement = null;
        
        // 1. 現在のノードがアップロードされたファイルのリンク内にあるかチェック
        $uploadedFileLinkElement = $node.closest('a[data-uploaded-file="true"]');
        if ($uploadedFileLinkElement.length > 0) {
          isInUploadedFileLink = true;
        }
        
        // 2. 選択範囲の開始位置がアップロードされたファイルのリンク内にあるかチェック
        if (!isInUploadedFileLink && range.sc) {
          let startNode = range.sc;
          if (startNode.nodeType === Node.TEXT_NODE) {
            startNode = startNode.parentNode;
          }
          $uploadedFileLinkElement = $(startNode).closest('a[data-uploaded-file="true"]');
          if ($uploadedFileLinkElement.length > 0) {
            isInUploadedFileLink = true;
          }
        }
        
        // 3. 選択範囲の終了位置がアップロードされたファイルのリンク内にあるかチェック
        if (!isInUploadedFileLink && range.ec) {
          let endNode = range.ec;
          if (endNode.nodeType === Node.TEXT_NODE) {
            endNode = endNode.parentNode;
          }
          $uploadedFileLinkElement = $(endNode).closest('a[data-uploaded-file="true"]');
          if ($uploadedFileLinkElement.length > 0) {
            isInUploadedFileLink = true;
          }
        }
        
        // 4. commonAncestorがアップロードされたファイルのリンク内にあるかチェック
        if (!isInUploadedFileLink && typeof range.commonAncestor === 'function') {
          try {
            const ancestor = range.commonAncestor();
            if (ancestor) {
              $uploadedFileLinkElement = $(ancestor).closest('a[data-uploaded-file="true"]');
              if ($uploadedFileLinkElement.length > 0) {
                isInUploadedFileLink = true;
              }
            }
          } catch (e) {
            // commonAncestorが利用できない場合は無視
          }
        }
        
        if (isInUploadedFileLink) {
          $uploadFileBtn.addClass('active');
        } else {
          $uploadFileBtn.removeClass('active');
        }
      }
      
      // 通常リスト（ul）のチェック
      const $ulBtn = $toolbar.find('button:has(.note-icon-unorderedlist)');
      if ($node.closest('ul').length) {
        $ulBtn.addClass('active');
      } else {
        $ulBtn.removeClass('active');
      }
      
      // 番号リスト（ol）のチェック
      const $olBtn = $toolbar.find('button:has(.note-icon-orderedlist)');
      if ($node.closest('ol').length) {
        $olBtn.addClass('active');
      } else {
        $olBtn.removeClass('active');
      }
      
      // 現在のブロック要素（p, h2, h3, h4, h5）を取得
      const $block = $node.closest('p, h1, h2, h3, h4, h5, h6');
      if ($block.length) {
        const tagName = $block.prop('tagName').toLowerCase();
        const className = $block.attr('class') || '';
        
        // スタイルドロップダウンの現在のスタイルを表示
        const $styleDropdown = $toolbar.find('.note-btn-group.note-style');
        const $styleButton = $styleDropdown.find('button');
        
        if ($styleButton.length) {
          let styleName = '';
          let dataValue = '';
          
          const styleMapping = {
            'h2': { label: 'h2', default: '見出し1' },
            'h3': { label: 'h3', default: '見出し2' },
            'h4': { label: 'h4', default: '見出し3' },
            'h5': { label: 'h5', default: '見出し4' },
          };
          
          if (tagName === 'p' && className.includes('c_small')) {
            styleName = this.styleLabels?.c_small || '小さい文字';
            dataValue = 'c_small';
          } else if (tagName === 'p') {
            styleName = this.styleLabels?.p || '標準';
            dataValue = 'p';
          } else if (styleMapping[tagName]) {
            const mapping = styleMapping[tagName];
            styleName = this.styleLabels?.[mapping.label] || mapping.default;
            dataValue = tagName;
          }
          
          if (styleName) {
            // ドロップダウンメニュー内のチェックマークを更新
            const $dropdownMenu = $styleDropdown.find('.note-dropdown-menu');
            $dropdownMenu.find('li').removeClass('checked');
            $dropdownMenu.find(`a[data-value="${dataValue}"]`).closest('li').addClass('checked');
          }
        }
      }
      
      // 文字色のチェックとパレットのチェックマーク
      const color = computedStyle.color;
      
      // RGB文字列を16進数に変換する関数
      const rgbToHex = (rgb) => {
        if (!rgb || rgb === 'transparent' || rgb === 'rgba(0, 0, 0, 0)') {
          return null;
        }
        const result = rgb.match(/\d+/g);
        if (!result) {
          return null;
        }
        return '#' + result.slice(0, 3).map(x => {
          const hex = parseInt(x).toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        }).join('').toLowerCase();
      };
      
      // 文字色の更新（明示的に色が設定されているかチェック）
      const hasExplicitColor = $node.parentsUntil('.note-editable').addBack().toArray().some(el => {
        return el.style && el.style.color !== '';
      }) || $node.closest('font[color]').length > 0;
      const hexColor = hasExplicitColor ? rgbToHex(color) : null;
      
      $toolbar.find('button.note-current-color-button[data-forecolor] .note-recent-color').css({
        'color': hasExplicitColor ? color : '#000000',
        'background-color': 'transparent'
      });
      
      // カラーパレットのチェックマークを更新
      $('button[data-event="foreColor"]').removeClass('selected');
      if (hexColor) {
        // 大文字小文字両方に対応
        $('button[data-event="foreColor"]').each(function() {
          const btnValue = $(this).attr('data-value');
          if (btnValue && btnValue.toLowerCase() === hexColor) {
            $(this).addClass('selected');
          }
        });
      }
      
      // 左寄せ・中央寄せ・右寄せのチェック（ドロップダウン内のボタンのみ、プレビューボタンは除外）
      const $alignBlock = $node.closest('p, h1, h2, h3, h4, h5, h6, div');
      if ($alignBlock.length) {
        const textAlign = $alignBlock.css('text-align') || computedStyle.textAlign || 'left';
        
        // すべての配置ボタンからactiveクラスを削除（dropdown-toggleは除外）
        $('.note-icon-align-left').parent('button').not('.dropdown-toggle').removeClass('active');
        $('.note-icon-align-center').parent('button').not('.dropdown-toggle').removeClass('active');
        $('.note-icon-align-right').parent('button').not('.dropdown-toggle').removeClass('active');
        
        // 現在の配置に応じてactiveクラスを追加（dropdown-toggleは除外）
        if (textAlign === 'left' || textAlign === 'start' || !textAlign) {
          $('.note-icon-align-left').parent('button').not('.dropdown-toggle').addClass('active');
        } else if (textAlign === 'center') {
          $('.note-icon-align-center').parent('button').not('.dropdown-toggle').addClass('active');
        } else if (textAlign === 'right' || textAlign === 'end') {
          $('.note-icon-align-right').parent('button').not('.dropdown-toggle').addClass('active');
        }
      }
    },

    // ========================================
    // スタイルドロップダウン初期化
    // ========================================
    initStyleDropdown() {
      // スタイルドロップダウンのUI表示をカスタマイズ
      const styleDropdown = $('.note-btn-group.note-style .note-dropdown-menu');
      const labels = this.styleLabels || {};
      
      // 各スタイルタグのラベルをカスタマイズ
      if (labels.p) {
        styleDropdown.find('a[data-value="p"]').not('.c_small').addClass('c_summernote_select_p').text(labels.p);
      }
      if (labels.h2) {
        styleDropdown.find('a[data-value="h2"]').addClass('c_summernote_select_h2').text(labels.h2);
      }
      if (labels.h3) {
        styleDropdown.find('a[data-value="h3"]').addClass('c_summernote_select_h3').text(labels.h3);
      }
      if (labels.h4) {
        styleDropdown.find('a[data-value="h4"]').addClass('c_summernote_select_h4').text(labels.h4);
      }
      if (labels.h5) {
        styleDropdown.find('a[data-value="h5"]').addClass('c_summernote_select_h5').text(labels.h5);
      }
      // カスタム項目はプレビュー要素を保持するためテキスト上書きしない
      if (labels.c_small) {
        styleDropdown.find('a[data-value="c_small"]').addClass('c_summernote_select_small');
      }

      // 汎用: styleTags のカスタム項目（オブジェクト定義）を解析
      const customStyleMap = {};
      styleDropdown.find('a').each(function() {
        const $a = $(this);
        const value = $a.attr('data-value');
        const $preview = $a.children().first();
        if (!$preview.length) return; // 文字リンクだけの標準項目はスキップ
        const tagName = ($preview.prop('tagName') || '').toLowerCase();
        const className = $preview.attr('class') || '';
        const inlineStyle = $preview.attr('style') || '';
        if (!value || !tagName) return;
        customStyleMap[value] = { tagName, className, inlineStyle };
      });

      // カスタム data-value のみを対象にクリック委譲（標準 p/h2/h3/h4 は対象外）
      const customKeys = Object.keys(customStyleMap);
      if (customKeys.length > 0) {
        const customSelector = customKeys.map((v) => `a[data-value="${v}"]`).join(',');
        styleDropdown.off('click.applyCustomStyles').on('click.applyCustomStyles', customSelector, (e) => {
          const $a = $(e.currentTarget);
          const value = $a.attr('data-value');
          const conf = customStyleMap[value];
          if (!conf) return;

          e.preventDefault();
          this.editor.summernote('editor.recordUndo');
          // 対象タグへ正規化
          this.editor.summernote('formatBlock', conf.tagName);

          try {
            const range = this.editor.summernote('createRange');
            const $editable = this.editorElement.next('.note-editor').find('.note-editable');
            if (!range || !$editable.length) return;
            this.applyClassAndStyleToBlocks(range, $editable, conf.tagName, conf.className, conf.inlineStyle);
          } catch (_) {}

          setTimeout(() => $('.note-dropdown-menu').removeClass('show'), 0);
        });
      }

      // 「標準」選択時に、カスタムスタイル（class/style）を除去して純粋な <p> に戻す
      // 標準の既定挙動（formatBlock('p')）は妨げないため preventDefault はしない
      const customClassList = Object.values(customStyleMap)
        .map((c) => c.className)
        .filter((c) => !!c);
      const customInlineStyles = Object.values(customStyleMap)
        .map((c) => c.inlineStyle)
        .filter((s) => !!s);

      styleDropdown.off('click.resetStandard').on('click.resetStandard', 'a[data-value="p"]', (e) => {
        // 既定のスタイル適用後にクレンジング（次の tick）
        setTimeout(() => {
          try {
            const range = this.editor.summernote('createRange');
            const $editable = this.editorElement.next('.note-editor').find('.note-editable');
            if (!range || !$editable.length) return;
            this.removeCustomFromBlocks(range, $editable, 'p', customClassList, customInlineStyles);
          } catch (_) {}
        }, 0);
      });

      // 見出し（h2/h3/h4）選択時も、カスタム由来の class/style（特に font-size）を除去
      styleDropdown.off('click.resetHeadings').on('click.resetHeadings', 'a[data-value="h2"], a[data-value="h3"], a[data-value="h4"]', (e) => {
        setTimeout(() => {
          try {
            const range = this.editor.summernote('createRange');
            const $editable = this.editorElement.next('.note-editor').find('.note-editable');
            if (!range || !$editable.length) return;
            this.removeCustomFromBlocks(range, $editable, 'h1,h2,h3,h4,h5,h6', customClassList, customInlineStyles);
          } catch (_) {}
        }, 0);
      });
    },

    // ========================================
    // 画像イベント初期化
    // ========================================
    initImageEvents() {
      // 画像選択を検知して現在の画像を保持
      const editorContainer = this.editorElement.next('.note-editor');
      const $editable = editorContainer.find('.note-editable');
      
      // 画像クリック時の選択保持を強化
      editorContainer.on('mousedown.imageSelect', '.note-editable img', (e) => {
        this.selectedImageElement = e.currentTarget;
        this.imageEditTarget = $(e.currentTarget);
      });
      
      // 画像以外をクリックした時は選択をクリア
      editorContainer.on('mousedown.imageClear', '.note-editable', (e) => {
        if (!$(e.target).is('img') && !$(e.target).closest('img').length) {
          this.selectedImageElement = null;
          this.imageEditTarget = null;
        }
      });
      
      // ポップオーバー表示時に画像選択を維持
      editorContainer.on('summernote.image.dialog.shown', () => {
        // ポップオーバー内のボタンクリック時も画像選択を維持
        setTimeout(() => {
          $('.note-popover .note-btn').on('click.maintainSelection', (e) => {
            // 現在の選択画像を保持
            if (this.selectedImageElement) {
              this.imageEditTarget = $(this.selectedImageElement);
            }
          });
        }, 100);
      });

      // ========================================
      // エディタ内でのドラッグ&ドロップ無効化
      // ========================================
      
      // ドラッグ開始時
      $editable.on('dragstart.preventDrag', (e) => {
        e.preventDefault();
        return false;
      });
      
      // ドロップ時
      $editable.on('drop.preventDrop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
      
      // ドラッグオーバー時
      $editable.on('dragover.preventDragOver', (e) => {
        e.preventDefault();
        return false;
      });
    },

    // ========================================
    // コードビュートグル処理
    // ========================================
    handleCodeViewToggle() {
      // コードビューが開かれているか確認
      if (this.editor.summernote('codeview.isActivated')) {
        // 現在のコンテンツを取得してクリーンアップ
        const currentContents = this.editor.summernote('code');
        const cleanedContents = this.cleanupHtml(currentContents);
        
        // white-space: preが設定されたタグがあるかチェック
        const hasPreWhitespace = this.hasPreWhitespace(cleanedContents);
        
        const options = {
          indent_size: 2,
          indent_char: ' ',
          max_preserve_newlines: 0,
          preserve_newlines: false,
          indent_inner_html: true,
          wrap_line_length: 0,
          indent_empty_lines: false,
          end_with_newline: false
        };

        // コードビュー領域を取得して整形
        const codeviewElement = this.editorElement.siblings('.note-editor').find('.note-codable');
        if (codeviewElement.length > 0) {
          // white-space: preが設定されたタグがある場合はbeautifyを実行しない
          if (hasPreWhitespace) {
            console.debug('white-space: pre detected, skipping beautify');
            codeviewElement.val(cleanedContents);
          } else {
            // beautifyを使って整形
            let formattedCode = beautify.html(cleanedContents, options);
            // 特定のケースのみ余分な空白を除去（改行や構造は保持）
            formattedCode = this.removeSpecificWhitespace(formattedCode);
            codeviewElement.val(formattedCode);
          }
        }
      }
    },

    // ========================================
    // スタイル適用ヘルパーメソッド
    // ========================================
    // 共通: ブロックへ class/style を適用
    applyClassAndStyleToBlocks(range, $editable, tagName, className, inlineStyle) {
      const processed = new Set();
      const applyTo = ($block) => {
        if (!$block || !$block.length) return;
        const el = $block.get(0);
        if (processed.has(el)) return;
        if (className) $block.addClass(className);
        if (inlineStyle) $block.attr('style', inlineStyle);
        processed.add(el);
      };
      if (typeof range.nodes === 'function') {
        range.nodes().forEach((node) => {
          const base = node && node.nodeType === 1 ? node : (node ? node.parentNode : null);
          if (!base) return;
          const $block = $(base).closest(tagName, $editable[0]);
          applyTo($block);
        });
      } else if (typeof range.commonAncestor === 'function') {
        const $block = $(range.commonAncestor()).closest(tagName, $editable[0]);
        applyTo($block);
      }
    },

    // 共通: class/style を除去
    removeCustomFromBlocks(range, $editable, tagSelector, classList, inlineStyles) {
      const processed = new Set();
      const cleanse = ($block) => {
        if (!$block || !$block.length) return;
        const el = $block.get(0);
        if (processed.has(el)) return;
        if (classList && classList.length) $block.removeClass(classList.join(' '));
        // 空の class 属性は削除
        const cls = ($block.attr('class') || '').trim();
        if (!cls) $block.removeAttr('class');
        const styleText = ($block.attr('style') || '');
        if (styleText) {
          let newStyle = styleText;
          if (inlineStyles && inlineStyles.some((s) => s && s.trim() === newStyle.trim())) {
            newStyle = '';
          } else {
            const parts = newStyle.split(';').map((p) => p.trim()).filter(Boolean);
            const filtered = parts.filter((p) => !/^font-size\s*:/i.test(p));
            newStyle = filtered.join('; ');
          }
          if (newStyle.trim()) $block.attr('style', newStyle);
          else $block.removeAttr('style');
        }
        processed.add(el);
      };
      if (typeof range.nodes === 'function') {
        range.nodes().forEach((node) => {
          const base = node && node.nodeType === 1 ? node : (node ? node.parentNode : null);
          if (!base) return;
          const $block = $(base).closest(tagSelector, $editable[0]);
          cleanse($block);
        });
      } else if (typeof range.commonAncestor === 'function') {
        const $block = $(range.commonAncestor()).closest(tagSelector, $editable[0]);
        cleanse($block);
      }
    },

    // ========================================
    // Summernote破棄
    // ========================================
    destroySummernote() {
      if (this.editor) {
        // イベントリスナーをクリーンアップ
        if (this.editorElement) {
          this.editorElement.off('summernote.codeview.toggled');
          const editorContainer = this.editorElement.next('.note-editor');
          const $editable = editorContainer.find('.note-editable');
          const $toolbar = editorContainer.find('.note-toolbar');
          
          editorContainer.off('mousedown.imageSelect');
          editorContainer.off('mousedown.imageClear');
          editorContainer.off('summernote.image.dialog.shown');
          
          $editable.off('dragstart.preventDrag');
          $editable.off('drop.preventDrop');
          $editable.off('dragover.preventDragOver');
          $editable.off('mouseup.updateToolbar keyup.updateToolbar');
          
          $toolbar.off('click.updateToolbar');
          
          // 色ボタンのイベントもクリーンアップ
          $toolbar.off('click.colorUpdate');
          
          // ポップオーバー内のボタンイベントもクリーンアップ
          $('.note-popover .note-btn').off('click.maintainSelection');
        }
        
        this.editor.summernote('destroy');
        this.editor = null;
        this.editorElement = null;
        this.selectedImageElement = null;
        this.imageEditTarget = null;
      }
    },

    // ========================================
    // ボタン作成メソッド
    // ========================================
    // ファイルアップロードボタン
    createUploadFileButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="fa fa-upload"/>',
        tooltip: 'ファイルアップロード',
        container: 'body',
        click: () => {
          const fileInput = $('<input type="file" accept=".txt,.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"/>');
          fileInput.on('change', (event) => {
            const file = event.target.files[0];
            if (file) {
              const data = new FormData();
              data.append('image', file);
              $.ajax({
                url: this.uploadFileUrl,
                method: 'POST',
                data: data,
                contentType: false,
                processData: false,
                headers: {
                  "X-CSRF-TOKEN": this.csrfToken
                },
                success: (response) => {
                  const fileUrl = response.link;
                  context.invoke('editor.pasteHTML', `<a href="${fileUrl}" target="_blank" data-uploaded-file="true">${file.name}</a>`);
                },
                error: (jqXHR, textStatus, errorThrown) => {
                  console.error('ファイルのアップロードに失敗しました:', textStatus, errorThrown);
                  alert('ファイルのアップロードに失敗しました');
                }
              });
            }
          });
          fileInput.click();
        }
      });
      return button.render();
    },

    // カスタム画像挿入ボタン
    createCustomPictureButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-picture"/>',
        tooltip: '画像挿入',
        container: 'body',
        click: () => {
          this.showCustomImageDialog();
        }
      });
      return button.render();
    },

    // カスタムリンク挿入ボタン
    createCustomLinkButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-link"/>',
        tooltip: 'リンク挿入',
        container: 'body',
        click: () => {
          this.savedRange = this.editor.summernote('createRange');
          const linkText = this.savedRange.toString();
          const linkInfo = this.getLinkInfo(this.savedRange);
          this.showCustomLinkDialog(linkText, linkInfo);
        }
      });
      return button.render();
    },

    // カスタムインデントボタン
    createCustomIndentButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-align-indent"/>',
        tooltip: '字上げ',
        container: 'body',
        click: function(e) {
          context.invoke('editor.indent');
        }
      });
      return button.render();
    },

    // カスタム字下げボタン
    createCustomOutdentButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-align-outdent"/>',
        tooltip: '字下げ',
        container: 'body',
        click: function(e) {
          context.invoke('editor.outdent');
        }
      });
      return button.render();
    },

    // カスタム書式クリアボタン
    createCustomClearButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-eraser"/>',
        tooltip: 'クリア',
        container: 'body',
        click: function() {
          const $editable = context.layoutInfo.editable;
          context.invoke('editor.recordUndo');
          const range = context.invoke('editor.createRange');

          // タグごと削除（Unwrap）したい場合に、このリストに追加
          const tagsToUnwrap = ['b', 'strong', 'i', 'em', 'u', 'font'];
          // スタイルクリアの判断材料とする装飾タグのリスト（内部的に使用）
          const presentationalTags = ['b', 'strong', 'i', 'em', 'u', 'span', 'font'];

          if (range.isCollapsed()) {
            $editable.find('*').removeAttr('style');
            tagsToUnwrap.forEach(function(tagName) {
              $editable.find(tagName).replaceWith(function() {
                // 要素のHTMLを取得して、タグのみを削除し、内容の空白を正規化
                const innerHTML = $(this).html();
                // HTMLタグを除去して、前後の空白・改行を削除
                return innerHTML.replace(/<[^>]*>/g, '').replace(/^\s+|\s+$/g, '');
              });
            });
          } else {
            const candidateElements = new Set();
            range.nodes().forEach(function(node) {
              let currentNode = node;
              while (currentNode && !$(currentNode).is('.note-editable')) {
                if (currentNode.nodeType === 1) candidateElements.add(currentNode);
                currentNode = currentNode.parentNode;
              }
            });

            const elementsToUnwrap = [];
            const elementsToDeStyle = [];

            // ① 分析フェーズ
            candidateElements.forEach(function(el) {
              const $el = $(el);
              const tagName = $el.prop('tagName').toLowerCase();

              if (tagsToUnwrap.includes(tagName)) {
                elementsToUnwrap.push(el);
              } else {
                const decorativeDescendants = $el.find('*').filter(function() {
                  return candidateElements.has(this) && presentationalTags.includes(this.tagName.toLowerCase());
                });
                if (decorativeDescendants.length === 0) {
                  elementsToDeStyle.push(el);
                }
              }
            });

            // ② 実行フェーズ
            $(elementsToUnwrap).each(function() {
              // 要素のHTMLを取得して、タグのみを削除し、内容の空白を正規化
              const $this = $(this);
              const innerHTML = $this.html();
              // HTMLタグを除去して、前後の空白・改行を削除
              const cleanText = innerHTML.replace(/<[^>]*>/g, '').replace(/^\s+|\s+$/g, '');
              $this.replaceWith(cleanText);
            });
            $(elementsToDeStyle).each(function() {
              $(this).removeAttr('style');
            });
          }

          // ③ クリーンアップフェーズ
          // style属性もclass属性も持たないspanをUnwrapする
          $editable.find('span:not([style]):not([class])').each(function() {
            // 要素のHTMLを取得して、タグのみを削除し、内容の空白を正規化
            const innerHTML = $(this).html();
            // HTMLタグを除去して、前後の空白・改行を削除
            const cleanText = innerHTML.replace(/<[^>]*>/g, '').replace(/^\s+|\s+$/g, '');
            $(this).replaceWith(cleanText);
          });
        }
      });
      return button.render();
    },

    // 画像リンク設定ボタン
    createSetImageLinkButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="note-icon-link"/>',
        tooltip: 'リンクの編集',
        container: 'body',
        click: (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          let $img = null;
          if (this.imageEditTarget && this.imageEditTarget.length) {
            $img = this.imageEditTarget;
          } else if (this.selectedImageElement) {
            $img = $(this.selectedImageElement);
            this.imageEditTarget = $img;
          } else {
            $img = this.getSelectedImage();
            if ($img && $img.length) {
              this.imageEditTarget = $img;
            }
          }
          
          if ($img && $img.length > 0) {
            setTimeout(() => {
              this.showImageLinkDialog();
            }, 50);
          } else {
            alert('リンクを設定する画像を選択してください');
          }
        }
      });
      return button.render();
    },

    // 画像ALT設定ボタン
    createSetImageAltButton(context) {
      const ui = $.summernote.ui;
      const button = ui.button({
        contents: '<i class="fa fa-tag"/>',
        tooltip: '代替テキストの編集',
        container: 'body',
        click: (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          let $img = null;
          if (this.imageEditTarget && this.imageEditTarget.length) {
            $img = this.imageEditTarget;
          } else if (this.selectedImageElement) {
            $img = $(this.selectedImageElement);
            this.imageEditTarget = $img;
          } else {
            $img = this.getSelectedImage();
            if ($img && $img.length) {
              this.imageEditTarget = $img;
            }
          }
          
          if ($img && $img.length > 0) {
            setTimeout(() => {
              this.showImageAltDialog();
            }, 50);
          } else {
            alert('代替テキストを設定する画像を選択してください');
          }
        }
      });
      return button.render();
    },

    // ========================================
    // 画像ダイアログ関連
    // ========================================
    // カスタム画像ダイアログを表示
    showCustomImageDialog() {
      // 入力欄を初期化
      $('#wysiwyg-image-file').val('');
      $('#wysiwyg-image-error').hide();
      this.wysiwygSelectedFileName = null;
      
      // モーダルを表示
      this.openModal('wysiwyg-image-modal');
    },
    
    // Wysiwygエディタ用の画像ファイル選択処理
    handleWysiwygImageFileChange(event) {
      this.errors.wysiwyg_image_file = null;
      this.wysiwygSelectedFileName = null;

      const file = event.target.files[0];
      // ファイルの拡張子チェック
      if (file) {
        // MIMEタイプでファイル形式を確認
        const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        
        if (!validImageTypes.includes(file.type)) {
          this.errors = this.errors || {};
          this.errors.wysiwyg_image_file = '画像ファイルはjpg、png、gif形式のみ許可されています';
          event.target.value = ''; // 入力をクリア
          return;
        }
      }
      if (file) {
        this.wysiwygSelectedFileName = file.name;
      } else {
        this.wysiwygSelectedFileName = null;
      }
    },
    
    // 画像挿入実行
    insertWysiwygImage() {
      const imageFile = $('#wysiwyg-image-file')[0].files[0];
      
      // エラー表示をリセット
      this.errors.wysiwyg_image = null;
      this.errors.wysiwyg_image_file = null;

      // ファイルが指定されていない場合
      if (!imageFile) {
        this.errors.wysiwyg_image = '画像ファイルを選択してください';
        return;
      }
      
      // ファイルが選択されている場合はアップロード
      const data = new FormData();
      data.append('image', imageFile);
      
      $('.wysiwyg-image-insert').text('アップロード中...').prop('disabled', true);
      
      $.ajax({
        url: this.uploadImageUrl,
        method: 'POST',
        data: data,
        contentType: false,
        processData: false,
        headers: {
          "X-CSRF-TOKEN": this.csrfToken
        },
        success: (response) => {
          const uploadedImageUrl = response.link;
          
          // シンプルに画像を挿入
          this.editor.summernote('insertImage', uploadedImageUrl);
          
          this.closeModal('wysiwyg-image-modal');
          $('.wysiwyg-image-insert').text('画像挿入').prop('disabled', false);
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('画像のアップロードに失敗しました:', textStatus, errorThrown);
          this.errors.wysiwyg_image = 'エラー: アップロードに失敗しました。';
          $('.wysiwyg-image-insert').text('画像挿入').prop('disabled', false);
        }
      });
    },

    // 画像リンク設定モーダルを開く
    showImageLinkDialog() {
      // imageEditTargetは既にボタンクリック時に設定済み
      if (!this.imageEditTarget || this.imageEditTarget.length === 0) {
        alert('リンクを設定する画像を選択してください');
        return;
      }
      
      // 現在のリンク情報を取得
      const $existingLink = this.imageEditTarget.closest('a');
      const href = $existingLink.length ? ($existingLink.attr('href') || '') : '';
      const isNewWindow = $existingLink.length ? ($existingLink.attr('target') === '_blank') : false;

      $('#wysiwyg-image-link-url').val(href);
      $('#wysiwyg-image-link-new-window').prop('checked', isNewWindow);

      this.openModal('wysiwyg-image-link-modal');
    },

    // 画像ALT設定モーダルを開く
    showImageAltDialog() {
      // imageEditTargetは既にボタンクリック時に設定済み
      if (!this.imageEditTarget || this.imageEditTarget.length === 0) {
        alert('代替テキストを設定する画像を選択してください');
        return;
      }
      
      // 現在のalt値を取得
      const alt = this.imageEditTarget.attr('alt') || '';
      $('#wysiwyg-image-alt-text').val(alt);

      this.openModal('wysiwyg-image-alt-modal');
    },

    // 画像リンク設定の保存
    applyImageLink() {
      if (!this.imageEditTarget) {
        this.closeModal('wysiwyg-image-link-modal');
        return;
      }
      const $img = this.imageEditTarget;
      const url = $('#wysiwyg-image-link-url').val();
      const newWindow = $('#wysiwyg-image-link-new-window').is(':checked');

      // リンクを更新
      const $existingLink = $img.closest('a');
      const trimmed = (url || '').trim();
      if (trimmed === '') {
        if ($existingLink.length) {
          $img.unwrap();
        }
      } else {
        if ($existingLink.length) {
          $existingLink.attr('href', trimmed);
          if (newWindow) {
            $existingLink.attr('target', '_blank');
          } else {
            $existingLink.removeAttr('target');
          }
        } else {
          const $link = $('<a/>').attr('href', trimmed);
          if (newWindow) $link.attr('target', '_blank');
          $img.wrap($link);
        }
      }

      // Summernoteの内部状態を更新
      const currentHTML = this.editor.summernote('code');
      this.editor.summernote('code', currentHTML);

      this.imageEditTarget = null;
      this.closeModal('wysiwyg-image-link-modal');
    },

    // 画像ALT設定の保存
    applyImageAlt() {
      if (!this.imageEditTarget) {
        this.closeModal('wysiwyg-image-alt-modal');
        return;
      }
      const $img = this.imageEditTarget;
      const alt = $('#wysiwyg-image-alt-text').val();

      // altを更新
      if (alt && alt.trim()) {
        $img.attr('alt', alt.trim());
      } else {
        $img.removeAttr('alt');
      }

      // Summernoteの内部状態を更新
      const currentHTML = this.editor.summernote('code');
      this.editor.summernote('code', currentHTML);

      this.imageEditTarget = null;
      this.closeModal('wysiwyg-image-alt-modal');
    },
    
    // ========================================
    // リンクダイアログ関連
    // ========================================
    // カスタムリンクダイアログを表示
    showCustomLinkDialog(linkText, linkInfo) {
      // リンク変更モードかどうか
      const isEditMode = linkInfo !== null;
      
      // モーダルのタイトルを変更
      $('#wysiwyg-link-modal .modal-content__title').text(isEditMode ? 'リンクの変更' : 'リンクの挿入');
      
      // ボタンテキストを変更
      $('#wysiwyg-link-submit-button').text(isEditMode ? '変更' : '挿入');
      
      // 入力欄を初期化
      $('#wysiwyg-link-text').val(isEditMode ? linkInfo.text : linkText || '');
      $('#wysiwyg-link-url').val(isEditMode ? linkInfo.url : '');
      $('#wysiwyg-link-new-window').prop('checked', isEditMode ? linkInfo.isNewWindow : false);
      
      // リンク情報をdata属性に保存
      this.currentLinkInfo = linkInfo;
      
      // モーダルを表示
      this.openModal('wysiwyg-link-modal');
    },
    
    // リンク挿入実行
    insertWysiwygLink() {
      this.errors.wysiwyg_link_url = null;

      let text = $('#wysiwyg-link-text').val();
      const url = $('#wysiwyg-link-url').val();
      if(text == ''){
        text = url;
      }
      const newWindow = $('#wysiwyg-link-new-window').is(':checked');
      
      if (!url) {
        this.errors.wysiwyg_link_url = 'リンクURLを入力してください';
        return;
      }
      
      // 保存した選択範囲を復元
      if (this.savedRange) {
        this.editor.summernote('editor.restoreRange', this.savedRange);
      }
      
      if (this.currentLinkInfo) {
        // 既存リンクの更新
        const $link = $(this.currentLinkInfo.element);
        
        // リンクテキストを更新
        if ($link.text() !== text) {
          $link.text(text);
        }
        
        // URLを更新
        $link.attr('href', url);
        
        // target属性を更新
        if (newWindow) {
          $link.attr('target', '_blank');
        } else {
          $link.removeAttr('target');
        }
      } else {
        // 新規リンク挿入
        const selection = this.savedRange.toString();
        
        if (selection === '') {
          // 選択範囲がない場合は直接HTMLを挿入
          const linkHtml = `<a href="${url}"${newWindow ? ' target="_blank"' : ''}>${text}</a>`;
          this.editor.summernote('editor.pasteHTML', linkHtml);
        } else {
          // 選択範囲がある場合は選択テキストにリンクを適用
          this.editor.summernote('createLink', {
            text: text, // ユーザーが入力したテキストを使用
            url: url,
            isNewWindow: newWindow
          });
        }
      }
      
      // リンク情報とレンジをクリア
      this.currentLinkInfo = null;
      this.savedRange = null;
      
      this.closeModal('wysiwyg-link-modal');
    },
    
    // ========================================
    // 画像・リンク共通ヘルパー
    // ========================================
    // 画像選択検出ヘルパー
    getSelectedImage() {
      try {
        // 1. imageEditTargetが既に設定されている場合は優先
        if (this.imageEditTarget && this.imageEditTarget.length && this.imageEditTarget.is('img')) {
          return this.imageEditTarget;
        }
        
        // 2. 最後にクリックした画像要素を優先
        if (this.selectedImageElement && $(this.selectedImageElement).length) {
          const $selected = $(this.selectedImageElement);
          if ($selected.is('img') && $selected.closest('.note-editable').length) {
            return $selected;
          }
        }
        
        // 3. 現在の選択範囲から画像を検索
        const range = this.editor.summernote('createRange');
        const $editable = this.editorElement.next('.note-editor').find('.note-editable');
        if (!range || !$editable.length) return null;
        
        const ancestor = range.commonAncestor();
        
        // 選択範囲内の画像を検索
        let $img = null;
        if (ancestor.nodeType === 1 && ancestor.tagName.toLowerCase() === 'img') {
          $img = $(ancestor);
        } else {
          $img = $(ancestor).find('img').first();
          if (!$img.length) {
            $img = $(ancestor).closest('img', $editable[0]);
          }
        }
        
        // 4. 見つかった画像が有効かチェック
        if ($img && $img.length && $img.closest('.note-editable').length) {
          return $img;
        }
        
        return null;
      } catch (e) {
        console.warn('getSelectedImage error:', e);
        return this.selectedImageElement ? $(this.selectedImageElement) : null;
      }
    },
    
    // カーソル位置のリンク情報を取得
    getLinkInfo(range) {
      // カーソル位置の要素
      const ancestor = range.commonAncestor();
      
      // アンカータグを探す
      let $anchor = $(ancestor).closest('a');
      
      // アンカータグが見つかったらその情報を返す
      if ($anchor.length > 0) {
        return {
          text: $anchor.text(),
          url: $anchor.attr('href') || '',
          isNewWindow: $anchor.attr('target') === '_blank',
          element: $anchor[0]
        };
      }
      
      return null;
    },

    // DOM要素から直接クリーンアップを行う関数
    cleanupDomElement(element) {
      if (!element) return;

      // 空のstyle属性を持つ要素のみを検索して削除
      const elementsWithEmptyStyle = element.querySelectorAll('[style=""]');
      elementsWithEmptyStyle.forEach(element => {
        element.removeAttribute('style');
      });

      // 不要な要素を削除する関数
      const removeUnnecessaryElements = (node) => {
        if (!node) return;

        // インライン要素とブロック要素のリスト（brは除外）
        const inlineElements = ['span', 'em', 'strong', 'i', 'b', 'u', 's', 'small', 'mark', 'del', 'ins', 'sub', 'sup'];
        const listElements = ['ul', 'ol'];
        
        // 要素ノードの場合
        if (node.nodeType === 1) {
          const tagName = node.tagName.toLowerCase();

          // brタグは常に保持
          if (tagName === 'br') {
            // brの親がspanで、spanの親がpの場合、spanを削除してbrを直接pの下に移動
            const parentSpan = node.parentElement;
            if (parentSpan && parentSpan.tagName.toLowerCase() === 'span') {
              const parentP = parentSpan.parentElement;
              if (parentP && parentP.tagName.toLowerCase() === 'p') {
                // brをpの直下に移動
                parentP.insertBefore(node, parentSpan);
                // spanが空になったので削除
                parentSpan.remove();
                return;
              }
            }
            return;
          }

          // 子要素を再帰的に処理（後ろから処理して削除による影響を防ぐ）
          Array.from(node.children).reverse().forEach(child => {
            removeUnnecessaryElements(child);
          });
          
          // インライン要素の処理
          if (inlineElements.includes(tagName)) {
            // テキストを持つ場合は保持（ただし、brのみを含むspanは除外）
            const hasOnlyBr = node.children.length === 1 && node.children[0].tagName.toLowerCase() === 'br';
            if (node.textContent.trim() && !hasOnlyBr) {
              return;
            }

            // 子要素にbrがある場合は、brを親要素の直下に移動して、このインライン要素は削除
            const brChild = node.querySelector('br');
            if (brChild) {
              const parent = node.parentElement;
              if (parent) {
                parent.insertBefore(brChild, node);
              }
            }

            // 空のインライン要素を削除
            node.remove();
          }
          // リスト要素の処理
          else if (listElements.includes(tagName)) {
            // リストアイテムを持つ場合は保持（<li>要素が存在するだけで有効とする）
            const hasListItems = Array.from(node.children).some(child => 
              child.tagName.toLowerCase() === 'li'
            );
            
            // <li>要素が存在しない場合のみ削除
            if (!hasListItems) {
              node.remove();
            }
          }
        }
      };

      // 要素内のすべてのノードに対して不要な要素の削除を実行
      removeUnnecessaryElements(element);

      // リストアイテム内の空行を削除
      const listItems = element.querySelectorAll('li');
      listItems.forEach(li => {
        // リストアイテム内のテキストノードを処理
        Array.from(li.childNodes).forEach(child => {
          if (child.nodeType === 3) { // テキストノード
            // 連続した改行を1つに置換
            child.textContent = child.textContent.replace(/\n\s*\n/g, '\n');
            // 前後の余分な改行を削除
            child.textContent = child.textContent.replace(/^\n+|\n+$/g, '');
            // 空のテキストノードを削除
            if (!child.textContent.trim()) {
              child.remove();
            }
          }
        });
      });


      // 条件に合致する場合に入力を空にする（customClearボタン用の特別な処理）
      const hasTextContent = element.textContent.trim() !== '';
      const hasParagraphs = element.querySelectorAll('p, h1, h2, h3, h4, h5, h6').length > 0;
      const hasLists = element.querySelectorAll('ul, ol').length > 0;
      const hasImages = element.querySelectorAll('img').length > 0;
      const hasLinks = element.querySelectorAll('a').length > 0;

      if (!hasTextContent && !hasParagraphs && !hasLists && !hasImages && !hasLinks) {
        console.debug('init editor.');
        element.innerHTML = '';
      }
    },

    // HTML文字列をクリーンアップする関数
    cleanupHtml(contents) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = contents;

      this.cleanupDomElement(tempDiv);

      return tempDiv.innerHTML;
    },

    // white-space: preが設定されたタグがあるかチェックする関数
    hasPreWhitespace(html) {
      // HTML文字列内にwhite-space: preが含まれているかチェック
      return html.includes('white-space: pre');
    },

    // 特定のケースのみ余分な空白を除去する関数（改行や構造は保持）
    removeSpecificWhitespace(html) {
      return html
        // インライン要素内の前後の空白のみを除去（ブロック要素は除外）
        .replace(/(<(?:span|em|strong|i|b|u|font|a)[^>]*>)\s+([^\s<])/g, '$1$2')
        .replace(/([^\s>])\s+(<\/(?:span|em|strong|i|b|u|font|a)>)/g, '$1$2')
        // ブロック要素内でテキストが1行の場合のみ前後空白を除去
        .replace(/(<(?:p|h[1-6]|div)[^>]*>)\s+([^<\n]+?)\s+(<\/(?:p|h[1-6]|div)>)/g, '$1$2$3');
    },


    // getCleanContentメソッドも更新（保存時にクリーンアップ）
    getCleanContent() {
      const currentContents = this.editor.summernote('code');
      const cleanedContents = this.cleanupHtml(currentContents);
      return cleanedContents;
    }
  },

  beforeDestroy() {
    this.destroySummernote();
  }
}
